import apiClient from '@/services/axios'

export async function del(venueId, role, categoryId) {
  var response = await apiClient.delete(`/PersonalTodos/Category/${venueId}/${role}/${categoryId}`)
  if (response) {
    return response.data
  }

  throw new Error('Unable to delete personal todo.')
}